import React from 'react';

import ManagedCheckbox from 'components/form/managed_input/checkbox';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';

import type { CustomField } from 'bundles/apex/custom_fields/types';
import type { Value } from './types';

const inputTypesByFieldType = {
  url: 'text',
  url_collection: 'textarea',
};

interface Props {
  customField: CustomField,
  name?: string;
  value: Value;
  onChange?: (changes: Record<string, Value>) => void;
  onValueChange?: (newValue: Value) => void;
}

export default function ApexCustomFieldInput({
  customField,
  name,
  value,
  onChange = () => {},
  onValueChange = () => {},
}: Props) {
  const props = {
    label: customField.label,
    name,
    value,
    onChange,
    onValueChange,
  };

  if (customField.type === 'boolean') {
    return <ManagedCheckbox {...props} value={!!value} />;
  } else if (customField.options) {
    return (
      <ManagedFormGroup {...props} includeBlank type="select">
        <Options options={customField.options.map(value => ({ label: value, value }))} />
      </ManagedFormGroup>
    );
  } else {
    const type = inputTypesByFieldType[customField.type] || customField.type;
    return <ManagedFormGroup {...props} type={type} />;
  }
}
